import type { Image } from '#payload-types'

export default (image: Ref<Image | null>) => {
  return computed(() => {
    const srcset: string[] = [`${image.value?.url} ${image.value?.width}w`]

    if (image.value?.sizes) {
      Object.entries(image.value.sizes).forEach(([key, value]) => {
        if (key !== 'opengraph' && value.url) {
          srcset.push(`${value.url} ${value.width}w`)
        }
      })
    }

    return srcset.join(', ')
  })
}
